'use client';

import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchCustomizationDetails } from '@/components/organisms/preferences/api';
import { updateCSSVariable } from '@/lib/utils/helpers/util-helpers';
import useThemeStore from '@/store/theme-store';

export default function ThemeInitializer() {
  const { setPreferedPrimaryHexColor } = useThemeStore();

  const { data: customizationData } = useQuery({
    queryKey: ['customization'],
    queryFn: fetchCustomizationDetails,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  });

  useEffect(() => {
    if (customizationData?.background_color_hex) {
      // Update the theme store
      setPreferedPrimaryHexColor(customizationData.background_color_hex);

      // Update the CSS custom property for --color-primary
      updateCSSVariable(
        '--color-primary',
        customizationData.background_color_hex
      );
    }
  }, [customizationData, setPreferedPrimaryHexColor]);

  return null;
}
